import type { Language, RoomId } from "../components/Localization";

const roomNames: Record<Language, Record<RoomId, string>> = {
  hu: {
    residence: "A REZIDENCIA",
    dining: "TÁLALÓ",
    mirror: "TÜKÖRTEREM",
    salon: "SZALON",
    estate: "A PETKIEK URADALMA",
    legacy: "MÁRIAFFIÉK ÖRÖKSÉGE",
    war: "A II. VILÁGHÁBORÚ ÉS AMI UTÁNA KÖVETKEZETT",
    extra: "EXTRA",
  },
  ro: {
    residence: "REȘEDINȚA",
    dining: "OFICIUL DE SERVIRE",
    mirror: "SALA OGLINZILOR",
    salon: "SALONUL",
    estate: "DOMENIUL FAMILIEI PETKI",
    legacy: "MOȘTENIREA FAMILIEI MÁRIAFFI",
    war: "AL DOILEA RĂZBOI MONDIAL ȘI URMĂRILE SALE",
    extra: "EXTRA",
  },
  en: {
    residence: "THE RESIDENCE",
    dining: "SERVING ROOM",
    mirror: "MIRROR ROOM",
    salon: "SALON",
    estate: "THE PETKI ESTATE",
    legacy: "THE MÁRIAFFI LEGACY",
    war: "WORLD WAR II AND ITS AFTERMATH",
    extra: "EXTRA",
  },
  de: {
    residence: "DIE RESIDENZ",
    dining: "SPEISEZIMMER",
    mirror: "SPIEGELSAAL",
    salon: "SALON",
    estate: "DAS LANDGUT DER FAMILIE PETKI",
    legacy: "DAS ERBE DER FAMILIE MÁRIAFFI",
    war: "DER ZWEITE WELTKRIEG UND SEINE FOLGEN",
    extra: "EXTRA",
  },
};

export function getRoomName(id: RoomId, language: Language) {
  return roomNames[language][id];
}
